module.exports = __webpack_public_path__ + "static/media/components-icon-large.39d430d3.svg";